<template>
  <megabit-base-dialog :show-dialog="true" :width="1024">
    <template v-slot:body>
      <v-sheet v-if="isLoading" class="pa-3" dark>
        <v-skeleton-loader
          class="mx-auto"
          :max-width="1024"
          max-height="768"
          type="card"
        ></v-skeleton-loader>
      </v-sheet>
      <v-card v-else dark>
        <v-card-title class="align-self-center">
          <span class="text-h6">Cadastro de Empresas (alt+r)</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense>
              <v-col cols="4" sm="2" md="2" lg="2">
                <c-input
                  :label="'Código'"
                  :placeholder="'Código'"
                  :maxLength="6"
                  v-model="form.codigo"
                />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="4" lg="3">
                <v-card class="d-flex  flex-row rounded secondary" dense>
                  <v-radio-group v-model="form.ativo" dense row>
                  <span class="ml-2 mr-2">Grupo</span>
                    <v-radio
                      v-for="option in optionsAtivo"
                      :key="option.value"
                      :label="option.text"
                      :value="option.value"
                      class="customClass"
                    ></v-radio>
                  </v-radio-group>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-tabs v-model="tab">
                <v-tabs-slider color="red"></v-tabs-slider>

                <v-tab>Dados</v-tab>
                <v-tab>Crediário</v-tab>

                <v-tabs-items v-model="tab" :transition="false">
                  <v-tab-item :transition="false">
                    <v-card dark>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="6" sm="3" md="2" lg="2">
                            <c-input-documento
                              v-model="form.cgc"
                              :isBrasil="!isParaguai"
                            />
                          </v-col>
                          <v-col cols="12" sm="9" md="4" lg="4">
                            <c-input
                              label="Nome"
                              placeholder="Digite o Nome"
                              :maxLength="35"
                              v-model="form.nome"
                            />
                          </v-col>
                          <v-col cols="12" md="6" lg="6">
                            <c-input
                              label="Razão Social"
                              placeholder="Digite a Razão Social"
                              :maxLength="80"
                              :minLength="3"
                              :isRequired="true"
                              v-model="form.razaoSocial"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4" sm="2" md="2" lg="2">
                            <c-input-cep
                              v-model="form.cep"
                              label="CEP"
                              placeholder="Digite o CEP"
                              :maxLength="8"
                              @keyUp="consultaCep($event)"
                            >
                            </c-input-cep>
                          </v-col>
                          <v-col cols="12" sm="10" md="8" lg="6">
                            <c-input
                              v-model="form.endereco"
                              label="Endereço"
                              placeholder="Digite o endereco"
                              :maxLength="45"
                            />
                          </v-col>
                          <v-col cols="3" lg="2">
                            <c-input
                              v-model="form.numero"
                              label="Número"
                              placeholder="Número"
                              :maxLength="8"
                            />
                          </v-col>
                          <v-col cols="8" sm="6" md="2" lg="2">
                            <c-input
                              v-model="form.complemento"
                              label="Complemento"
                              placeholder="Complemento"
                              :maxLength="25"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6" sm="4" md="4" lg="2">
                            <c-input
                              v-model="form.bairro"
                              label="Bairro"
                              placeholder="Digite o Bairro"
                              :maxLength="45"
                            ></c-input>
                          </v-col>
                          <v-col cols="10" sm="6" md="6" lg="4">
                            <c-select
                              :lista="cidadeList"
                              :item.sync="form.cidade"
                              itemText="DESCRICAO"
                              itemValue="CODIGO"
                              rotulo="Cidade"
                              disable-lookup
                              @searchinput="search($event, 'cidade')"
                              @input="updateUF"
                            />
                          </v-col>
                          <v-col cols="2" sm="2 " md="1" lg="1">
                            <c-input
                              v-model="form.uf"
                              label="UF"
                              placeholder="Digite UF"
                              :maxLength="2"
                            />
                          </v-col>
                          <v-col cols="12" sm="8" md="6" lg="3">
                            <c-select
                              :lista="paisList"
                              :item.sync="form.pais"
                              itemText="DESCRICAO"
                              itemValue="CODIGO"
                              rotulo="Pais"
                              @searchinput="search($event, 'pais')"
                            />
                          </v-col>
                          <v-col cols="6" sm="4" md="4" lg="2">
                            <c-input
                              v-model="form.fone"
                              label="Telefone"
                              placeholder="Digite um Telefone"
                              :maxLength="16"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" sm="8" md="6" lg="6">
                            <c-select
                              :lista="tipoVendaList"
                              :item.sync="form.tipoVenda"
                              itemText="DESCRICAO"
                              itemValue="CODIGO"
                              rotulo="Condição de Pagamento"
                              @searchinput="search($event, 'tipoVenda')"
                            />
                          </v-col>
                          <v-col cols="6" sm="6" md="4" lg="3">
                            <c-select
                              item-text="TIPO"
                              item-value="TIPO"
                              rotulo="Classificação"
                              :lista="companyTypeList"
                              :item.sync="form.tipoEmpresa"
                            />
                          </v-col>
                          <v-col cols="6" sm="6" md="4" lg="3">
                            <c-select
                              item-text="NOME"
                              item-value="NOME"
                              rotulo="Ramo Atividade"
                              :lista="lineBusinessList"
                              :item.sync="form.ramoAtividade"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field
                              v-model="form.email"
                              label="E-mail"
                              placeholder="Digite um email"
                              maxlength="50"
                              class="text-caption"
                              dense
                              outlined
                              dark
                              :rules="formRules.emailFormat"
                            />
                          </v-col>
                          <v-col cols="6">
                            <c-input
                              v-model="form.obsBalcao"
                              label="Observação Balcão"
                              placeholder="Observação Balcão"
                              :maxLength="100"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card dark>
                      <v-card-text>
                        <v-row dense>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input
                              label="RG"
                              placeholder="Digite o RG"
                              :maxLength="20"
                              v-model="form.rg"
                            />
                          </v-col>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input-date
                              label="Data Emissão RG"
                              placeholder="Ex. 01/01/2000"
                              :minLength="0"
                              :inputMask="'##/##/####'"
                              v-model="form.dataEmissaoRG"
                              @change="
                                verificarDataAcimaDeHoje(
                                  $event,
                                  'dataNascimento'
                                )
                              "
                            />
                          </v-col>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input
                              label="Orgão Emissor"
                              placeholder="Orgão emissor RG"
                              :maxLength="12"
                              v-model="form.orgaoEmissor"
                            />
                          </v-col>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input-date
                              label="Data Nascimento"
                              placeholder="Ex. 01/01/2000"
                              :minLength="0"
                              :inputMask="'##/##/####'"
                              v-model="form.dataNascimento"
                              @change="
                                verificarDataAcimaDeHoje(
                                  $event,
                                  'dataNascimento'
                                )
                              "
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <c-input
                              label="Pai"
                              placeholder="Digite o nome do pai"
                              :maxLength="35"
                              v-model="form.pai"
                            />
                          </v-col>
                          <v-col cols="6">
                            <c-input
                              label="Mãe"
                              placeholder="Digite o nome da mãe"
                              :maxLength="35"
                              v-model="form.mae"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <c-input
                              label="Conjuje"
                              placeholder="Digite o nome do conjuje"
                              :maxLength="35"
                              v-model="form.conjuje"
                            />
                          </v-col>
                          <v-col cols="2">
                            <c-input
                              label="Código Conjuje"
                              placeholder="Código"
                              :maxLength="6"
                              v-model="form.codigoConjuje"
                            />
                          </v-col>
                        </v-row>
                        <v-divider class="mb-3"></v-divider>
                        <v-row dense>
                          <v-col cols="2">
                            <c-input
                              label="Dias Atraso"
                              placeholder="Dias atraso"
                              :maxLength="6"
                              v-model="form.diasAtraso"
                            />
                          </v-col>
                          <v-col cols="1" sm="2">
                            <c-input-money
                              v-model="form.percentualJuros"
                              label="% Juros"
                              dark
                              dense
                              outlined
                              reverse
                              v-bind:valueWhenIsEmpty="'0'"
                              v-bind:options="{
                                locale: 'pt-BR',
                                prefix: '',
                                suffix: componentSuffix,
                                length: 11,
                                precision: componentPrecision,
                              }"
                            />
                          </v-col>
                          <v-spacer />

                          <v-col cols="3" sm="6" lg="3">
                            <c-input-money
                              v-model="form.valorCredito"
                              label="Limite Crédito"
                              dark
                              dense
                              outlined
                              reverse
                              v-bind:valueWhenIsEmpty="'0'"
                              v-bind:options="{
                                locale: 'pt-BR',
                                prefix: '',
                                suffix: componentSuffix,
                                length: 11,
                                precision: componentPrecision,
                              }"
                            />
                          </v-col>
                          <v-col cols="3" sm="6" lg="3">
                            <c-input-money
                              :value="cmpSaldoLimiteCredito"
                              label="Saldo Limite Crédito"
                              dark
                              dense
                              outlined
                              reverse
                              readonly
                              v-bind:valueWhenIsEmpty="'0'"
                              v-bind:options="{
                                locale: 'pt-BR',
                                prefix: '',
                                suffix: componentSuffix,
                                length: 11,
                                precision: componentPrecision,
                              }"
                            />
                          </v-col>
                        </v-row>
                        <v-divider class="mb-3"></v-divider>
                        <v-row dense>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input-date
                              label="Data Cadastro"
                              placeholder="Ex. 01/01/2000"
                              :minLength="0"
                              :inputMask="'##/##/####'"
                              readonly
                              v-model="form.dataCadastro"
                              :messages="form.cadastradoPor"
                            />
                          </v-col>
                          <v-col cols="6" sm="3" lg="2">
                            <c-input-date
                              label="Data Atualização"
                              placeholder="Ex. 01/01/2000"
                              :minLength="0"
                              :inputMask="'##/##/####'"
                              readonly
                              v-model="form.dataAtualizacaoCadastro"
                              :messages="form.alteradoPor"
                            />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons
          @goBack="goBack()"
          @submitForm="submitForm()"
          :disabled-save="!isDocumentoValido"
        />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
// funcoes
import {
  validaCpfCnpj,
  validaRUC,
  consultaViaCep,
  eventKeyPress,
  emailFormat,
} from '@/utils/utils'

// componentes
import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cInput from '@/components/shared/base-input/BaseInput.vue'
import cInputDocumento from '@/components/shared/base-input/BaseInputCpfCnpj.vue'
import cInputCep from '@/components/shared/base-input/BaseInputCEP.vue'
import cInputDate from '@/components/shared/base-input/BaseInputMaskDate'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'

import { formRegisterMixin } from '@/mixins/component/form/FormRegisterMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'

import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  mixins: [formRegisterMixin, currencyMixin],
  components: {
    cSelect,
    cInput,
    cInputCep,
    cInputDate,
    cInputDocumento,
    cInputMoney,
    MegabitBaseDialog,
    FormButtons,
  },
  data: () => ({
    tab: 0,
    isLoading: true,
    optionsAtivo: [
      { text: 'Ativo', value: 'S' },
      { text: 'Inativo', value: 'N' },
    ],
    oldValorCredito: 0, // para controlar no front o saldo real do limite de credito durante uma edição
    form: {
      codigo: null,
      nome: null,
      razaoSocial: null,
      cgc: null,
      cep: null,
      endereco: null,
      numero: null,
      bairro: null,
      cidade: null,
      pais: null,
      tipoEmpresa: null,
      tipoVenda: null,
      uf: null,
      fone: null,
      ativo: 'S',
      obsBalcao: null,
      ramoAtividade: null,
      dataNascimento: null,
      dataEmissaoRG: null,
      orgaoEmissor: null,
      pai: null,
      mae: null,
      conjuje: null,
      codigoConjuje: null,
      valorCredito: 0,
      saldoLimiteCredito: 0,
    },
    cidadeList: [],
    paisList: [],
    tipoVendaList: [],
  }),

  computed: {
    ...mapState('authModule', ['authUser']),

    ...mapGetters({
      countryList: 'countryModule/getCountryList',
      cityList: 'cityModule/getComboBoxList',
      companyTypeList: 'companyTypeModule/getCompanyTypeList',
      paymentConditionList: 'paymentConditionsModule/getComboBoxList',
      lineBusinessList: 'lineBusinessModule/getLineBusinessList',
      optionCurrencies: 'systemModule/getSystemCurrencies',
      currentSystem: 'systemModule/getCurrentSystem',
    }),
    formRules() {
      const rules = {
        emailFormat: [emailFormat(true)],
        requiredField: [(value) => !!value || 'Campo Obrigatório.'],
      }

      return rules
    },
    isParaguai() {
      return this.form.pais
        ? this.form.pais.DESCRICAO == 'PARAGUAY' ||
            this.form.pais.DESCRICAO == 'PARAGUAI'
        : false
    },

    isDocumentoValido() {
      // se digitar o cpf ou cnpj ira validar, caso contrario sempre será verdadeiro para salvar
      let documento = this.form.cgc
      if (documento) {
        if (this.isParaguai) {
          return validaRUC(documento)
        } else {
          return validaCpfCnpj(documento)
        }
      } else return false
    },

    componentSuffix() {
      return ''
    },
    componentPrecision() {
      return 2
    },

    cmpSaldoLimiteCredito: {
      get: function() {
        const diferencaValorCredito =
          this.form.valorCredito - this.oldValorCredito

        const limiteCredito =
          this.form.saldoLimiteCredito + diferencaValorCredito

        return limiteCredito
      },
    },
  },
  methods: {
    ...mapActions({
      insert: 'companyModule/insertCompany',
      update: 'companyModule/updateCompany',
      getCompany: 'companyModule/getCompany',
    }),
    ...mapActions('cityModule', ['getCities']),
    ...mapActions('countryModule', ['getCountries']),
    ...mapActions('companyTypeModule', ['getCompanyTypes']),
    ...mapActions('lineBusinessModule', ['getLinesBusiness']),
    ...mapActions('paymentConditionsModule', ['getPaymentConditionsAPI']),
    ...mapActions('dialogModule', [
      'setShowLoadingDialog',
      'setLoadingDialogMessage',
    ]),
    keyPress($event) {
      eventKeyPress($event)
    },

    async consultaCep($event) {
      try {
        let param = $event.target.value ?? null
        if (!param || param.replace(/[^0-9]+/g, '').length <= 7) return

        const response = await consultaViaCep(param)

        // quando o cep nao existe, retorna erro: true
        if (response && response.erro) return

        this.form.endereco = response.logradouro.toUpperCase()
        this.form.complemento = response.complemento.toUpperCase()
        this.form.bairro = response.bairro.toUpperCase()
        this.form.uf = response.uf

        // buscar os dados do gestao
        await this.getDados(
          { page: 1, hibrido: response.ibge },
          'cidade',
          this.getCities,
          'cityList'
        )
        this.form.cidade = this.cityList[0]

        await this.getDados(
          { page: 1, descricao: 'BRASIL' },
          'pais',
          this.getCountries,
          'countryList'
        )
        this.form.pais = this.countryList[0]
        // fim
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    updateUF(value) {
      if (value && value.UF.length > 0) {
        this.form.uf = value.UF
      }
    },

    search($event, property) {
      try {
        clearTimeout(this.timer)
        let param = $event.target.value ?? null

        if (!param || param.trim().length <= 0) return

        param = param
          .trim()
          .split('-')[0]
          .trim()

        this.timer = setTimeout(() => {
          let payload =
            property == 'pais'
              ? { page: 1, descricao: param }
              : { page: 1, hibrido: param }

          let fnc
          let list
          if (property == 'cidade') {
            fnc = this.getCities
            list = 'cityList'
          } else if (property == 'pais') {
            fnc = this.getCountries
            list = 'countryList'
          } else {
            fnc = this.getPaymentConditionsAPI
            list = 'paymentConditionList'
          }

          if (!this.form[property] || this.form[property].CODIGO !== param) {
            this.getDados(payload, property, fnc, list)
          }
        }, 600)
      } catch (error) {
        console.log('error', error)
      }
    },

    async getDados(payload, property, fnc, ownerList) {
      try {
        await fnc(payload)
        this[`${property}List`] = this[ownerList]
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async setData() {
      try {
        await this.fetch()

        if (this.$route.params && this.$route.params.id > 0) {
          let company = await this.getCompany(this.$route.params.id)
          if (company.cidade)
            this.cidadeList.push({
              ...company.cidade,
              DESCRICAO: company.cidade.DESCRICAO + ' - ' + company.cidade.UF,
            })

          if (company.pais) this.paisList.push(company.pais)

          if (company.tipoVenda) {
            this.tipoVendaList.push({
              ...company.tipoVenda,
              DESCRICAO:
                company.tipoVenda.CODIGO + ' - ' + company.tipoVenda.NOME,
            })
          }
          this.oldValorCredito = company.valorCredito
          this.form = {
            ...company,
          }
          this.isUpdate = !this.isUpdate
        } else {
          // iniciar com o tipo balcao
          const type = this.companyTypeList.filter(
            (element) => element.TIPO == 'Balcao'
          )
          this.form.tipoEmpresa = type[0] ?? null

          const country = this.countryList.filter(
            (element) => element.DESCRICAO == 'BRASIL'
          )
          this.form.pais = country[0] ?? null
        }
        this.isLoading = !this.isLoading
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async fetch() {
      try {
        await this.getCompanyTypes()
        await this.getLinesBusiness()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    async verificarDataAcimaDeHoje(value, property) {
      let nValue = value.split('/')
      nValue = nValue[2] + nValue[1] + nValue[0]

      let date = new Date().toLocaleDateString('pt-BR')
      let nDate = date.split('/')
      nDate = nDate[2] + nDate[1] + nDate[0]

      if (nDate < nValue) {
        await this.$nextTick()
        this.form[property] = date
      }
    },
    async submitForm() {
      // if (this.form.dataNascimento > ) {

      // }
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Verifique os campos em vermelho')
        return
      }
      try {
        let response
        if (!this.isUpdate) {
          response = await this.insert(this.form)
        } else {
          response = await this.update({
            ...this.form,
            id: this.$route.params.id,
          })
        }
        this.$toasted.success(response)

        this.$refs.form.resetValidation()
        this.oldValorCredito = 0
        Object.keys(this.form).forEach((key) => {
          if (typeof this.form[key] === 'number') this.form[key] = 0
          else this.form[key] = null
        })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  created() {
    this.setData()
  },
}
</script>

<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.8em;
}
</style>
